<template>
  <div>
  <Breadcrumbs main="Services" title="Create Budget" />
    <div class="container-fluid" v-if="systemCategories">
      <div class="row">
        <div class="col-xl-9 col-md-12 offset-xl-1 box-col-12">
          <div class="file-content">
            <div class="card">
              <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5>Create Budget</h5>
                <span>What is your spending plan for this month?</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                    <div class="row">
                        <div class="col-md-8 offset-0 offset-md-2">
                          <div class="form-group">
                            <label>Select Account <span class="text-danger">*</span></label>
                            <select v-model="form.accountNumber" placeholder="Select From Account *" class="form-control" id="AccountNumber" name="AccountNumber" required="required"><option :value="form.accountNumber" disabled>{{form.accountNumber ? form.accountNumber : 'Select From Account *'}}</option>
                              <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-8 offset-0 offset-md-2 budget-card mb-5">
                            <h5 class="total-budget-text">Total Budget</h5>
                            <h4 class="total-amount-text">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(totalAmount)}}</h4>
                        </div>
                        <div class="col-md-6" v-for="category in updateSystemCategorywithColor" :key="category.id">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6">
                                    <div class="icon-wrapper mb-3 d-flex align-items-center">
                                        <div>
                                          <i class="icon" :class="category.icon ? category.icon : 'fa fa-database'" :style="[{'color':`#${category.color}`}, {'background-color':`#${category.color + '40'}`}]"></i>
                                        </div>
                                        <h6 class="ml-2 mt-2">{{category.name}}</h6>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <form>
                                      <div class="form-group">
                                        <input type="text" @paste.prevent v-model="category.amount" @change="amountValue(category)" @keypress="isNumber" @keyup="formatNum($event, category.id)" class="form-control" placeholder="Enter Amount">
                                      </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 my-4 text-center">
                            <button data-toggle="modal" data-target="#addCategory" type="button" class="btn btn-outline-light ml-2"><i class="fa fa-plus mr-2"></i>Add New</button>
                        </div>
                        <div class="col-md-12 mt-2 mb-4 text-center">
                            <button type="button" class="btn btn-danger btn-md ml-2" @click="createUserBudget">
                              <div v-if="loading">
                                <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                              </div>
                              <div v-else>Create Budget</div>
                            </button>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      </div>
    </div>
    <!-- add category modal -->
    <div class="modal fade" id="addCategory" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
                <h5 class="modal-title pl-2" style="font-size: 20px">Add Budget Category</h5>
                <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="text-dark">Category Name</label>
              <input type="text" v-model="newBudgetCategory.categoryName" class="form-control" placeholder="Enter Category Name">
            </div>
            <div class="form-group mb-4">
              <label class="text-dark">Select Color Tag</label>
              <div class="color-tag-wrapper d-flex justify-content-between">
                <div v-for="(color, index) in colorArray" :key="index" :class="[selectedIndex.includes(index) ? 'selected' : '']" class="circle" @click="getColor(color.color, index)" :style="{'background-color': `#${color.color}`}"></div>
              </div>
            </div>
            <div class="budget-btn-section text-center mt-5 my-4 row">
                <div class="col-sm-12">
                  <button @click="addNewBudgetCategory" type="button" class="btn btn-danger ml-2"><i class="fa fa-plus mr-2"></i>Add</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="loader-12"></div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import moment from 'moment';
  import $ from 'jquery';
  import { decrypt } from '../../_services/encryption';
  export default {
    components: {
    },
    filters: {
      moment: function (date) {
        return moment(date).format('Do MMMM, YYYY');
      }
    },
    data:() => ({
      form: {
        accountNumber: '',
        categories:[],
        platform: 1,
        shouldRollOver: true,
      },
      totalAmount: '0.00',
      uniqueID: '',
      loading: false,
      newBudgetCategory: {
        categoryName: '',
        color: '',
      },
      selectedIndex: [],
      colorArray: [
        { id: 0, color: 'FF0304' }, 
        { id: 1, color:'FF2400' },
        { id: 2, color:'FF540b' },  
        { id: 3, color:'FF3a86' }, 
        { id: 4, color: 'FFffbe' }, 
        { id: 5, color: 'FFff0a' }, 
        { id: 6, color:'FF8ac9' }, 
        { id: 7, color:'FF0004' }, 
        { id: 8, color: 'FF4509' }
      ],
      systemColorArray: [
        { id: 0, color: 'FFFBC0', icon: 'fa fa-bus' }, 
        { id: 1, color:'FF2a9d', icon: 'fa fa-money' },
        { id: 2, color:'FF4464', icon: 'fa fa-life-bouy' },  
        { id: 3, color:'FFFFCC', icon: 'fa fa-random' }, 
        { id: 4, color: 'FFD3D3', icon: 'fa fa-database' }, 
        { id: 5, color: 'FF6FCE', icon: 'fa fa-cutlery' }, 
        { id: 6, color:'FFe9c4', icon: 'fa fa-briefcase' }, 
        { id: 7, color:'FFf4a2', icon: 'fa fa-suitcase' }, 
        { id: 8, color: 'FFe76f', icon: 'fa fa-users' },
        { id: 9, color: 'FFe639', icon: 'fa fa-home' }, 
        { id: 10, color: 'FFB081', icon: 'fa fa-shopping-bag' }, 
        { id: 11, color:'FF9c66', icon: 'fa fa-plus-square' }, 
        { id: 12, color:'FF7209', icon: 'fa fa-exchange' }, 
        { id: 13, color: 'FF4509', icon: 'fa fa-exchange' }
      ],
      updateSystemCategorywithColor: [],
    }),
    computed: {
      ...mapState({
        account: state => state.dashboard.dashboardData,
        systemCategories: state => state.budget.systemCategories,
      }),
      userAccounts(){
        return this.account ? this.account.accounts : null;
      },
      systemCategoriesWithAmount(){
        return this.systemCategories.map(category => {
          return {
            ...category,
            amount: '0.00',
            color: '',
            icon: '',
          };
        });
      },
    },
    mounted() {
      this.loading = true;
      this.$store.dispatch('budget/getSystemCategories').then(response => {
        if(response.status === 200) {
          this.loading = false;
          const category = this.systemCategoriesWithAmount.map((item, index) => index);
          const colorArray = this.systemColorArray.map((item, index) => index);
          category.forEach(item => {
            return colorArray.map((color, index )=> {
              if(item === index) {
                this.systemCategoriesWithAmount[item].color = this.systemColorArray[color].color;
                this.systemCategoriesWithAmount[item].icon = this.systemColorArray[color].icon;
              }
            });
          });
          this.updateSystemCategorywithColor = this.systemCategoriesWithAmount;
        }
      });
    },
    methods : {
      getColor(color, index) {
        this.newBudgetCategory.color = color;
        if (this.selectedIndex.includes(index)) 
          this.removeColor(index);
        else
          this.selectedIndex = [];
        this.selectedIndex.push(index);
      },
      removeColor(index) {
        this.selectedIndex.splice(this.selectedIndex.indexOf(index),1);
      },
      generateUUID() {
        // generate unique id
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = (d + Math.random()*16)%16 | 0;
          d = Math.floor(d/16);
          return (c==='x' ? r : (r&0x3|0x8)).toString(16);
        });
        this.uniqueID = uuid;
        return uuid;
      },
      addNewBudgetCategory(){
        this.generateUUID();
        this.systemCategoriesWithAmount.push({
          id: this.uniqueID,
          name: this.newBudgetCategory.categoryName,
          color: this.newBudgetCategory.color,
          amount: '0.00'
        });
        this.newBudgetCategory = {
          categoryName: '',
          color: '',
        };
        this.selectedIndex = [];
        $('#addCategory').modal('hide');
      },
      formatInput(event) {
        this.form.amount = event.target.value;
        const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
        this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
      },
      amountValue(value) {
        const amount = value.amount;
        const id = value.id;
        const name = value.name;
        const color = value.color;
        const icon = value.icon;

        this.updateSystemCategorywithColor.map((item, index) => {
          if(item.id === id) {
            this.updateSystemCategorywithColor[index].amount = amount;
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.updateSystemCategorywithColor[index].amount = formatter.format(this.updateSystemCategorywithColor[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
          }
        });

        if(amount === '' || amount === '0.00') {
          const index = this.form.categories.findIndex(item => item.id === id);
          this.form.categories.splice(this.form.categories.indexOf(index), 1);
          const sum = this.form.categories.reduce((a, b) => a + b.amount, 0);
          this.totalAmount = sum;
        } else {
          const filteredArray = this.form.categories.filter((item) => {
            return item.name === name;
          });
          if(filteredArray.length > 0) {
            filteredArray[0].amount = Number(amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
          } else {
            this.form.categories.push({
              id: id,
              name: name,
              amount: Number(amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
              color: color,
              imageURL: icon,
            });
          } 
          const data = this.form.categories.splice(this.form.categories.indexOf(value), 1);
          data.forEach(item => {
            this.form.categories.push(item);
            const sum = this.form.categories.reduce((a, b) => a + b.amount, 0);
            this.totalAmount = sum;
          });
        }
      },
      createUserBudget() {
        if(this.form.accountNumber === '') {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Kindly select an account',
          });
          return;
        } if(this.form.categories === 0) {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: 'Kindly add at least one category',
          });
          return;
        } else {
          this.loading = true;
          this.$store.dispatch('budget/createBudget', this.form).then((response) => {
            if(response.status === 200) {
              this.loading = false;
              this.$swal({
                type: 'success',
                title: 'Success',
                text: 'Budget created successfully',
              });
              this.$router.push({ name: 'budget-management' });
            }
          }).catch((error) => {
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.loading = false;
            this.$swal({
              type: 'error',
              title: 'Oops...',
              text: objError.errors[0],
            });
          });
        }
      },
      formatNum(event, id) {
        this.updateSystemCategorywithColor.map((item, index) => {
          if(item.amount === '') {
            item.amount = '0.00';
          }
          if(item.id === id) {
            this.updateSystemCategorywithColor[index].amount = event.target.value;
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.updateSystemCategorywithColor[index].amount = formatter.format(this.updateSystemCategorywithColor[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            if(event.key === 'Backspace' || event.key === 'Delete') {
              if(event.target.value.length <= 4) {
                const formatter = new Intl.NumberFormat('en-US');
                this.updateSystemCategorywithColor[index].amount = formatter.format(this.updateSystemCategorywithColor[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                if(event.target.value.length < 2) {
                  this.updateSystemCategorywithColor[index].amount = '0.00';
                }
              } else {
                this.updateSystemCategorywithColor[index].amount = event.target.value;
                const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
                this.updateSystemCategorywithColor[index].amount = formatter.format(this.updateSystemCategorywithColor[index].amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
                return;
              }
            }
          }
        });
      },
      isNumber(event) {
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
    },
  };
</script>
<style scoped>
.budget-card {
  height: 100%;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  background: #FFF4F2;
  text-align: center;
  margin-top: 20px;
}
.total-budget-text {
  color: #E41617;
  font-size: 14px;
  font-weight: 400;
}
.total-amount-text {
  font-size: 21px;
  color: #E41617;
  font-weight: 500;
  padding-top: 10px;
}
.icon {
  font-size: 20px;
  /* color: #E41617; */
  /* background: #806b6b00; */
  /* opacity: 0.2; */
  width: 52px;
  padding: 17px;
  border-radius: 50px;
}
.circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  cursor: pointer;
}
.selected {
  border: 1px solid #888888;
  box-shadow: inset 0px 0px 0px 3px white;
}
</style>